import { PhaseSeasonYear } from "../interfaces/PhaseSeasonYear";
import t from "../i18n";

export function formatPhaseForDisplay(phase: string): string {
  if (phase === "Diplomacy") {
    return t("Movement");
  }
  return t(phase);
}

export function formatPSYForDisplay(psy: PhaseSeasonYear): string {
  return `${t(psy.season)} ${psy.year} ${formatPhaseForDisplay(psy.phase)}`;
}

export function formatPSYForDisplayShort(psy: PhaseSeasonYear): string {
  return `${psy.season.charAt(0)}${psy.year}${formatPhaseForDisplay(
    psy.phase,
  ).charAt(0)}`;
}
